<template>
  <div class="mt-3">
    <div class="row g-3">
      <div
        v-for="(item, index) in shortcuts"
        :key="index"
        class="col-6 col-sm-4 text-center mt-3 mb-2"
      >
        <router-link :to="item.path" class="shortcut-link">
          <div class="shortcut-card">
            <img :src="item.icon" class="shortcut-icon" />
          </div>
          <div class="shortcut-text">{{ item.label }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>


<script>
import orderIcon from '@/assets/images/order-shortcut.svg'
import cartIcon from '@/assets/images/cart-shortcut.svg'
import invoiceIcon from '@/assets/images/invoice.svg'
import tvIcon from '@/assets/images/tv-shortcut.svg'
import exchangeIcon from '@/assets/images/exchange-shortcut.svg'
import chartIcon from '@/assets/images/chart-pie-shortcut.svg'

export default {
  name: "QuickShortcuts",
  data() {
    return {
      shortcuts: [
        { label: "Offres", icon: orderIcon, path: "/suppliers/list" },
        { label: "Commandes", icon: cartIcon, path: "/orders/list" },
        { label: "Factures", icon: invoiceIcon, path: "/invoices/list" },
        { label: "Merchandising", icon: tvIcon, path: "/merchandising" },
        { label: "Echanges", icon: exchangeIcon, path: "/exchanges/list" },
        { label: "Stats", icon: chartIcon, path: "/reporting" }
      ]
    };
  }
};
</script>

<style scoped>
.shortcut-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.shortcut-card {
  background-color: #f8f8f8;
  border-radius: 14px;
  width: 70px;
  height: 70px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shortcut-icon {
  height: 34px;
}

.shortcut-text {
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

</style>
